import { OrderRefund } from "lib/types/generated/graphql-types"
import { OrderOperations } from "./OrderOperations"

export class Refund extends OrderOperations {
  constructor(refund: OrderRefund[]) {
    super(refund)
  }

  public completedRefunds(): OrderRefund[] {
    return this.completedList() as OrderRefund[]
  }

  public failedRefunds(): OrderRefund[] {
    return this.failedList() as OrderRefund[]
  }

  public getOnGoingRefund(): OrderRefund {
    const onGoingList = this.onGoingList() as OrderRefund[]
    return onGoingList[0]
  }

  public getPendingRefund(): OrderRefund {
    const pendingList = this.pendingList() as OrderRefund[]
    return pendingList[0]
  }

  public paymentTotal(isTaxIncludedInPrice: boolean): number {
    return this.completedRefunds()
      .map((refund) => {
        if (isTaxIncludedInPrice) return refund.totals.grandTotal
        return refund.totals.grandTotal + refund.totals.taxTotal
      })
      .reduce((a, b) => a + b, 0)
  }

  public giftCardTotal(): number {
    return this.completedRefunds()
      .map((refund) => refund.totals.giftCardTotal)
      .reduce((a, b) => a + b, 0)
  }

  public bonusTotal(): number {
    return this.completedRefunds()
      .map((bonus) => bonus.totals.bonusTotal)
      .reduce((a, b) => a + b, 0)
  }

  public orderLineRefundedAmount(orderLineId: string): number {
    return this.completedRefunds()
      .flatMap((refund) => refund.orderLines)
      .filter((ol) => ol.orderLineId === orderLineId)
      .reduce((total, ol) => total + ol.totalAmount, 0)
  }

  public orderLineRefundedQuantity(orderLineId: string): number {
    return this.completedRefunds()
      .flatMap((refund) => refund.orderLines)
      .filter((ol) => ol.orderLineId === orderLineId)
      .reduce((total, ol) => total + ol.quantity, 0)
  }

  public orderLineFullyRefunded(orderLineId: string, orderLineQuantity: number): boolean {
    return this.orderLineRefundedQuantity(orderLineId) === orderLineQuantity
  }

  public giftCardProductsRefundedAmount(giftCardId: string): number {
    return this.completedRefunds()
      .flatMap((refund) => refund.giftCardProducts)
      .filter((giftCard) => giftCard.giftCardProductId === giftCardId)
      .reduce((total, giftCard) => total + giftCard.priceAmount, 0)
  }

  public orderRefundedFee(): number {
    return this.completedRefunds().reduce((total, refund) => total + (refund?.fee?.amount ?? 0), 0)
  }

  public getRefundsOnOrderLine(orderLineId: string): OrderRefund[] {
    return this.completedRefunds()
      .filter((refund) =>
        refund.orderLines.some((ol) => ol.orderLineId === orderLineId)
      )
  }


  public getRefundedOrderLine(orderLineId: string): OrderRefund | undefined {
    return this.completedRefunds().find((refund) =>
      refund.orderLines.find((ol) => ol.orderLineId === orderLineId)
    )
  }
}
